import * as React from "react";
import { Form, Segment, Grid, Header, List, Checkbox, Dropdown, Message, DropdownItemProps, CheckboxProps, FormTextArea, FormField, GridColumn, GridRow, MessageHeader, MessageList, MessageItem, ListItem, FormGroup, FormInput, TableRow, TableCell, Divider } from "@/components/bp/bp-ui";
import { Formik, Field, FormikProps } from "formik";
import * as yup from "yup";
import { CaseRunCreateEvidenceModel, CaseRunCreateSampleModel, DeconvMainCaseRunCreateModel } from "@app/api2/api";
import SemanticField from "@app/components/SemanticField";
import { Constants } from "./Constants";
import { TranslationContext } from "../Contexts/TranslationContext";
import { BPButton } from "@/components/bp/bpbutton";
import { BPCheckbox } from "@/components/bp/bpcheckbox";
import ItemsList from "../Common/ItemsList";
import ItemsList2 from "../Common/ItemsList2";

interface IInformationDeconvMainProps {
    model: DeconvMainCaseRunCreateModel;
    onComplete: (values: FormState) => void;
}

class InformationDeconvMainState {
    initialValues: FormState;
    populationOptions: DropdownItemProps[];
    // isRangeOfContributors: boolean;
    isAIC: boolean;
}

export class FormState {
    description: string = '';
    numberOfContributors: string = '1-2';
    unknowns: string = '1';
    populationId: number = -1;
    contributors: Array<CaseRunCreateSampleModel> = [];
    evidence: Array<CaseRunCreateEvidenceModel> = [];
    rangeOfContributorsMin: number = 1;
    rangeOfContributorsMax: number = 2;
    isAIC: boolean = false;
}

export class InformationDeconvMain extends React.Component<IInformationDeconvMainProps, InformationDeconvMainState> {

    InformationDeconvMainValidationSchema: yup.AnyObjectSchema;

    InformactionMaxLrValidationSchema: () => yup.AnyObjectSchema;

    InformactionMaxLrRangeValidationSchema: () => yup.AnyObjectSchema;

    form: any = React.createRef();

    constructor(props, context) {
        super(props, context);

        this.InformactionMaxLrValidationSchema = () => yup.object().shape({
            description: yup.string().label(window.translation.caseRun.runDescription),
            unknowns: yup.number().min(0).integer().max(Constants.maxUnknowns).required().label(window.translation.caseRun.unknowns),
            populationId: yup.number().required().label(window.translation.common.population)
        });

        let $this = this;

        this.InformactionMaxLrRangeValidationSchema = () => yup.object().shape({
            description: yup.string().label(window.translation.caseRun.runDescription),
            rangeOfContributorsMin: yup.number().min(1).integer().max(Constants.maxNoc).required().label("min" + window.translation.caseRun.rangeOfContributors),
            rangeOfContributorsMax: yup.number().min(1).integer().max(Constants.maxNoc).required().label("max" + window.translation.caseRun.rangeOfContributors),

            unknowns: yup.string().required().label(window.translation.caseRun.unknowns).test('unknowns', window.translation.caseRun.numberOfContributorsError, function (value) {
                const { path, createError } = this;

                let parsed = $this.parseNumberOfContributors(value);

                if (parsed.min < 0 || parsed.max < 0)
                    return false;

                return true;
            }),
        });


        this.InformationDeconvMainValidationSchema = yup.object().shape({
            description: yup.string().label(window.translation.caseRun.runDescription),

            unknowns: yup.string().when('isAIC', {
                is: true,
                then: yup.string().required().label(window.translation.caseRun.unknowns),
                otherwise: yup.string().required().label(window.translation.caseRun.unknowns),
            }),

            populationId: yup.number().required().label(window.translation.common.population),
        });


        let parsed = this.parseNumberOfContributors(this.props.model.numberOfContributors);

        this.state = {
            initialValues: {
                description: this.props.model.description || "",
                numberOfContributors: this.props.model.numberOfContributors,
                unknowns: this.calcUnknown(parsed.min, parsed.max, this.props.model.hp),
                populationId: this.props.model.populationId && this.props.model.populations.some(x => x.id == this.props.model.populationId) ? this.props.model.populationId : null,
                contributors: this.props.model.hp,
                evidence: this.props.model.evidence,
                rangeOfContributorsMin: parsed ? parsed.min : 1,
                rangeOfContributorsMax: parsed ? parsed.max : 2,
                isAIC: this.props.model.parameters.filter(x => x.parameter == 'isAIC').map(m => m.value).shift() == "1"
            },
            isAIC: this.props.model.parameters.filter(x => x.parameter == 'isAIC').map(m => m.value).shift() == "1",
            populationOptions: this.props.model.populations.map((p) => ({ key: p.id, value: p.id, text: p.name }))
        };
    }

    parseNumberOfContributors = (noc: string) => {
        const sign = (noc || 0).toString().startsWith("-") ? "-" : "+";
        if (sign == "-")
            noc = noc.substring(1, noc.length);

        const range = noc != null ? noc.split("-") : null;

        if (range && range.length > 0) {
            // if (sign == "-")
            //     range
            const min = parseInt(range[0]) * (sign == "-" ? -1 : 1);
            const max = parseInt(range[range.length - 1]);

            return { min: Math.min(min, max), max: Math.max(min, max) };
        }

        return { min: 1, max: 2 };
    };

    calcUnknown = (nocMin: number, nocMax: number, contributors: Array<{ selected: boolean }>): string => {
        let unknowns: Array<number> = [];
        for (let noc = nocMin; noc <= nocMax; noc++) {
            let unknown = noc;
            //let hd = values.hd;
            //let hp = values.hp;
            unknown = noc - (contributors || []).filter(h => h.selected).length;
            unknowns.push(unknown);
        }

        if (unknowns.length == 1)
            return unknowns[0].toString()

        return unknowns.join("-");
    }

    formRender = ({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldTouched, setFieldValue }: FormikProps<FormState>) => {
        // var state = this.state;
        const dropdownChange = async (e, data, name?) => {
            if (name) {
                await setFieldValue(name, data.value);
                if (name == "numberOfContributors") {
                    // this.recalc(data.value, data.value)
                    recalcUnknownHp(data.value, data.value);
                }
            } else {
                await setFieldValue("populationId", data.value);
            }
        };

        const recalc = async (min, max) => {
            recalcUnknownHp(min, max);

            const noc = min != max ? [min, max].join("-") : min.toString();
            await setFieldValue("numberOfContributors", noc);
        }

        const evidenceChecked = async (id, evidence, value) => {
            // var evidence = values.evidence;

            evidence.selected = value;
            await setFieldValue("evidence", evidence);
        }

        const hpChecked = async (id, contrib, value: boolean) => {
            const hp = values.contributors;
            contrib.selected = value;
            await setFieldValue("contributors", hp);
            if (!values.isAIC)
                await recalcUnknownHp(values.numberOfContributors, values.numberOfContributors)
            else
                await recalcUnknownHp(values.rangeOfContributorsMin, values.rangeOfContributorsMax)
        }

        const recalcUnknownHp = async (nocMin, nocMax) => {
            await setFieldValue('unknowns', this.calcUnknown(nocMin, nocMax, values.contributors));
            this.setState({ ...this.state });
        }

        return (<TranslationContext.Consumer>{t => {
            const hpTitle = this.props.model.useHp && this.props.model.useHd ? t.caseRun.hpContributors : t.common.contributors;

            return <Form onSubmit={handleSubmit}>
                <SemanticField
                    name="description"
                    component={FormTextArea}
                    label={t.caseRun.runDescription} />

                <FormField>
                    <label>{t.common.population}</label>
                    <Dropdown search selection disabled={this.props.model.aic} options={this.state.populationOptions} value={values.populationId} onChange={dropdownChange} />
                </FormField>
                <FormField>
                    <Field
                        component={Checkbox}
                        label={t.parameter.names.isAIC}
                        name="isAIC"
                        onChange={async (e, p: CheckboxProps) => { await setFieldValue("isAIC", p.checked); this.setState({ isAIC: p.checked }); }}
                        checked={values.isAIC} />
                </FormField>
                <FormField>
                    <label>{values.isAIC ? t.caseRun.rangeOfContributors : t.caseRun.numberOfContributors}</label>
                    {values.isAIC ? (
                        <FormGroup>
                            <FormInput type="number" name="rangeOfContributorsMin" value={values.rangeOfContributorsMin} onBlur={handleBlur} onChange={async (e, d) => { await setFieldValue('rangeOfContributorsMin', parseInt(d.value) || 0); handleChange(e); await recalc(parseInt(d.value) || 0, values.rangeOfContributorsMax); }} width={3} />-<FormInput name="rangeOfContributorsMax" type="number" onBlur={handleBlur} value={values.rangeOfContributorsMax} onChange={async (e, d) => { await setFieldValue('rangeOfContributorsMax', parseInt(d.value)); handleChange(e); await recalc(values.rangeOfContributorsMin, parseInt(d.value)); }} width={3} />
                        </FormGroup>) : (
                        <Dropdown search selection options={[...Array(Constants.maxNoc).keys()].map(i => (i + 1).toString()).map(m => { return { key: m, value: m, text: m }; })} value={values.numberOfContributors} onChange={(e, data) => dropdownChange(e, data, "numberOfContributors")} />
                    )
                    }
                </FormField>
                <Grid>
                    <GridRow columns={3}>
                        {this.props.model.useHp &&
                            <GridColumn>
                                <ItemsList2
                                    filter={(item: CaseRunCreateSampleModel, filterText: string) => item.name?.toLowerCase().includes(filterText?.toLowerCase())}
                                    scrolling
                                    header={hpTitle}
                                    items={values.contributors}
                                    renderRow={(evidence: CaseRunCreateSampleModel) =>
                                        <ListItem key={`ev${evidence.id}`}>
                                            <BPCheckbox disabled={this.props.model.aic} checked={evidence.selected} label={evidence.name} onClick={(ev, data) => (hpChecked(evidence.id, evidence, data.checked))} />
                                        </ListItem>
                                    }
                                    footer={<><Divider /><FormField inline error={!!errors.unknowns}>
                                        <label>{this.props.model.useHp && this.props.model.useHd ? t.caseRun.hpUnknowns : t.common.unknowns}</label>
                                        <Field name="unknowns" readOnly={true} />
                                    </FormField>
                                    </>
                                    }
                                />

                                {/* <Header attached="top">{hpTitle}</Header>
                                <Segment attached>
                                    <List relaxed divided>
                                        {values.contributors.map((e, i) => (
                                            <ListItem key={e.id}>
                                                <BPCheckbox disabled={this.props.model.aic} checked={e.selected} label={e.name} onClick={(ev, data) => (hpChecked(e.id, i, data.checked))} />
                                            </ListItem>
                                        ))}
                                    </List>
                                    <FormField inline error={!!errors.unknowns}>
                                        <label>{this.props.model.useHp && this.props.model.useHd ? t.caseRun.hpUnknowns : t.common.unknowns}</label>
                                        <Field name="unknowns" readOnly={true} />
                                    </FormField>
                                </Segment> */}
                            </GridColumn>
                        }
                        <GridColumn>
                            <ItemsList2
                                filter={(item: CaseRunCreateEvidenceModel, filterText: string) => item.name?.toLowerCase().includes(filterText?.toLowerCase())}
                                scrolling
                                header={t.common.evidence}
                                items={values.evidence}
                                renderRow={(evidence: CaseRunCreateEvidenceModel) =>
                                    <ListItem key={`ev${evidence.id}`}>
                                        <BPCheckbox disabled={this.props.model.aic} checked={evidence.selected} label={evidence.name} onClick={(ev, data) => (evidenceChecked(evidence.id, evidence, data.checked))} />
                                    </ListItem>
                                }
                            />
                        </GridColumn>
                    </GridRow>
                </Grid>
                {Object.keys(errors).length > 0 &&
                    <Message negative>
                        <MessageHeader>{t.caseRun.errorsOnForm}</MessageHeader>
                        <MessageList>
                            {Object.keys(errors).map((k) => (<MessageItem key={k}>{errors[k]}</MessageItem>))}
                        </MessageList>
                    </Message>
                }
                <Segment basic clearing>
                    <BPButton floated="right" type="submit" positive primary>{t.caseRun.next}</BPButton>
                </Segment>
            </Form>
        }}</TranslationContext.Consumer>);
    };

    onSubmit = (values: FormState, bag) => {
        // values.isAIC = this.state.isRangeOfContributors;
        this.props.onComplete(values);
        // this.props.router.history.push("/parameters");
    };

    render() {
        return (
            <Formik innerRef={this.form} enableReinitialize={true} initialValues={this.state.initialValues} onSubmit={this.onSubmit} validationSchema={this.state.isAIC ? this.InformactionMaxLrRangeValidationSchema() : this.InformactionMaxLrValidationSchema()}>
                {(props) => {
                    return this.formRender(props)
                }}
            </Formik>
        );
    }
}
